// extracted by mini-css-extract-plugin
export default {"pagemargin":"eventlocationsdialog_pagemargin__FL516","pagesubtitle":"eventlocationsdialog_pagesubtitle__qjuVJ"};